<mat-sidenav-container fullscreen>

  <ng-content></ng-content>

</mat-sidenav-container>